import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  countCheckedHomeworks,
  countMatchingHomeworks,
  countMaterialsForStudents,
  countMaterialsForStudentsWithChapter,
  countStudentsWithTeacher,
  createMaterialsAllTime,
  filterMaterialsByMail,
  findCompletedControlSheets,
  findSubjectsForTeacher,
} from './StatisticsTeacherUtils';
import addedStudentStatisticsIcon from '../../../assets/img/added-student-statistics.svg';
import nhomeworkImprovmentImg from '../../../assets/img/homework-improvment-icon.svg';
import homeworkSentStudenImg from '../../../assets/img/homework-sent-studen-icon.svg';
import interactiveClIcon from '../../../assets/img/material-interactive-cl-icon.svg';
import pagesFirstSewingImg from '../../../assets/img/pages-first-sewing-icon.svg';
import {
  selectMaterials,
  selectNotebooks,
  selectStudents,
  selectTeachers,
} from '../../../redux/slices/statistics/additionalStatisticsSlice';
import {
  selectCurrentUser,
  selectSearchQuery,
  selectSelectedRole,
} from '../../../redux/slices/statistics/statisticsSlice';
import { StatisticsAddedMaterialsStudents } from '../StatisticsAddedMaterialsStudents/StatisticsAddedMaterialsStudents';
import { StatisticsInteractiveMaterials } from '../StatisticsInteractiveMaterials/StatisticsInteractiveMaterials';
import { StatisticsSquareSmall } from '../StatisticsSquareSmall/StatisticsSquareSmall';
import { StatisticsWorkMaterials } from '../StatisticsWorkMaterials/StatisticsWorkMaterials';
import './style.scss';

export const StatisticsTeacher = () => {
  const { t } = useTranslation();
  const currentSearchQuery = useSelector(selectSearchQuery);
  const currentUser = useSelector(selectCurrentUser);
  const students = useSelector(selectStudents);
  const teachers = useSelector(selectTeachers);
  const notebooks = useSelector(selectNotebooks);
  const materials = useSelector(selectMaterials);

  return (
    <div className="statistics-teacher statistics-content-block">
      {currentSearchQuery && currentUser && students && teachers && notebooks && materials && (
        <>
          <div className="statistics-content-block-bottom">
            <h2>
              {t('Teacher statistics')} {currentSearchQuery}
            </h2>

            <div className="statistics-content-block-row">
              <StatisticsSquareSmall
                icon={homeworkSentStudenImg}
                count={
                  currentUser && currentUser.email
                    ? countMatchingHomeworks(students, currentUser.email.replace(/\./g, ''))
                    : 0
                }
                text={'homework sent to students'}
              />
              <StatisticsSquareSmall
                icon={nhomeworkImprovmentImg}
                count={
                  currentUser && currentUser.email
                    ? countCheckedHomeworks(students, currentUser.email.replace(/\./g, ''))
                    : 0
                }
                text={'homework students have been checked'}
              />
              <StatisticsSquareSmall
                icon={pagesFirstSewingImg}
                count={findSubjectsForTeacher(students, currentUser.email.replace(/\./g, ''), notebooks)}
                text={'pages are verified in a notebook'}
              />

              <StatisticsSquareSmall
                icon={addedStudentStatisticsIcon}
                count={countStudentsWithTeacher(students, currentUser.email.replace(/\./g, ''))}
                text={'added to training'}
              />
            </div>

            <div className="statistics-content-block-row">
              <StatisticsWorkMaterials
                obj={createMaterialsAllTime(materials, currentUser.email)}
                text={'created over all time'}
                textTop={'educational materials'}
              />
              <StatisticsAddedMaterialsStudents
                totalCount={filterMaterialsByMail(materials, currentUser.email.replace(/\./g, ''), students).length}
                addedCount={countMaterialsForStudents(students, materials, currentUser.email.replace(/\./g, ''))}
                title={'of materials'}
                subTitle={'sent to students'}
              />
              <StatisticsInteractiveMaterials
                totalCount={countMaterialsForStudentsWithChapter(
                  students,
                  materials,
                  currentUser.email.replace(/\./g, ''),
                )}
                addedCount={findCompletedControlSheets(students, materials, currentUser.email.replace(/\./g, ''))}
                title={'КЛ'}
                subTitle={'added'}
                subTitleBottom={'checked'}
                icon={interactiveClIcon}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
